import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, languagesActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, languagesActions);

export default slice.reducer;
